"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = exports.StyledContentBlock = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
const ContentBlock_1 = require("./ContentBlock");
const flipIt = ({ flip, }) => {
    switch (flip) {
        case ContentBlock_1.Flips.Both:
            return (0, styled_components_1.css) `
        & > :first-child {
          order: 1;
        }

        & > :last-child {
          order: 0;
        }
      `;
        case ContentBlock_1.Flips.Horizontal:
            return bitcoincom_pkg_theme_1.media.md `
          & > :first-child {
            order: 1;
          }

          & > :last-child {
            order: 0;
          }
        `;
        case ContentBlock_1.Flips.Vertical:
            return (0, styled_components_1.css) `
        & > :first-child {
          order: 1;
        }

        & > :last-child {
          order: 0;
        }

        ${bitcoincom_pkg_theme_1.media.md `
          & > :first-child {
            order: 0;
          }

          & > :last-child {
            order: 1;
          }
        `}
      `;
        default:
            return (0, styled_components_1.css) ``;
    }
};
exports.StyledContentBlock = styled_components_1.default.div `
  ${({ theme, aside, flip }) => (0, styled_components_1.css) `
    margin: auto;
    max-width: 1440px;
    box-sizing: border-box;
    position: static;
    text-align: left;

    padding: 0 30px;

    flex-direction: column;

    ${flipIt({ flip })}

    ${bitcoincom_pkg_theme_1.media.sm `
        align-content:center;
        justify-content: center;
        padding: 0 ${theme.spacing.unit * 4}px;
      `}

      ${bitcoincom_pkg_theme_1.media.md `
        padding: 0 70px;
        flex-direction: row;
      `}

      ${bitcoincom_pkg_theme_1.media.lg `
        padding: 0 100px;
      `}

      /** aside styles */
      ${aside &&
    (0, styled_components_1.css) `
      display: flex;
      justify-content: space-between;

      ${flip === ContentBlock_1.Flips.None || flip === ContentBlock_1.Flips.Vertical
        ? (0, styled_components_1.css) `
            ${bitcoincom_pkg_theme_1.media.md `
                  & > :last-child {
                    text-align: right;
                  }
                  `}
          `
        : (0, styled_components_1.css) `
            ${bitcoincom_pkg_theme_1.media.md `
                  & > :last-child {
                    text-align: left;
                  }
                  `}
          `}
    `}
  `}
`;
exports.Content = styled_components_1.default.div `
  box-sizing: border-box;
  width: 100%;

  ${bitcoincom_pkg_theme_1.media.md `
    flex-basis: 50%;
    justify-content: center;
  `}
`;
//# sourceMappingURL=styled.js.map